var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "link-72") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interface",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(-115.000000, -2.000000)",
    fill: "#00D664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link-72",
    transform: "translate(115.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.625,0 C8.4875,0 7.35,0.4375 6.5625,1.3125 L5.5125,2.275 C5.1625,2.625 5.1625,3.15 5.5125,3.5 C5.8625,3.85 6.3875,3.85 6.7375,3.5 L7.7875,2.45 C8.75,1.4875 10.5,1.4875 11.4625,2.45 C11.9875,2.975 12.25,3.675 12.25,4.375 C12.25,5.075 11.9875,5.775 11.4625,6.2125 L10.5,7.2625 C10.15,7.6125 10.15,8.1375 10.5,8.4875 C10.675,8.6625 10.9375,8.75 11.1125,8.75 C11.2875,8.75 11.55,8.6625 11.725,8.4875 L12.775,7.4375 C13.5625,6.65 14,5.5125 14,4.375 C14,3.2375 13.5625,2.1 12.6875,1.3125 C11.9,0.4375 10.7625,0 9.625,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2625,10.5 L6.2125,11.55 C5.25,12.5125 3.5,12.5125 2.5375,11.55 C2.0125,11.025 1.75,10.325 1.75,9.625 C1.75,8.925 2.0125,8.225 2.5375,7.7875 L3.5,6.7375 C3.85,6.3875 3.85,5.8625 3.5,5.5125 C3.15,5.1625 2.625,5.1625 2.275,5.5125 L1.3125,6.5625 C0.4375,7.35 0,8.4875 0,9.625 C0,10.7625 0.4375,11.9 1.3125,12.6875 C2.1,13.5625 3.2375,14 4.375,14 C5.5125,14 6.65,13.5625 7.4375,12.6875 L8.4875,11.6375 C8.8375,11.2875 8.8375,10.7625 8.4875,10.4125 C8.1375,10.0625 7.6125,10.15 7.2625,10.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.225,4.55 L4.55,8.225 C4.2,8.575 4.2,9.1 4.55,9.45 C4.725,9.625 4.9875,9.7125 5.1625,9.7125 C5.3375,9.7125 5.6,9.625 5.775,9.45 L9.45,5.775 C9.8,5.425 9.8,4.9 9.45,4.55 C9.1,4.2 8.575,4.2 8.225,4.55 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.863755919156356026e123d48e86e6fc.svg";
export { ForwardRef as ReactComponent };